var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "#E7F7FE",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B7E6FB",
    d: "m21.59 25.772 8.978-.897 2.693 6.283-3.591 3.591 11.67 11.67 3.59-3.59 6.284 3.59-.897 8.08-1.796.897-9.874-1.796-6.284-4.488-7.182-8.08-5.386-9.874z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#26B5F3",
    d: "M49.253 41.93c-.395 0-.808-.125-1.203-.215a18 18 0 0 1-2.352-.7 3.59 3.59 0 0 0-4.452 1.795l-.395.826a23.7 23.7 0 0 1-4.794-3.59 23.6 23.6 0 0 1-3.59-4.794l.825-.377a3.59 3.59 0 0 0 1.796-4.453 19 19 0 0 1-.7-2.37c-.09-.395-.162-.808-.216-1.203a5.386 5.386 0 0 0-5.386-4.47h-5.404a5.39 5.39 0 0 0-4.022 1.795 5.39 5.39 0 0 0-1.31 4.31 34.24 34.24 0 0 0 9.713 19.748 34.24 34.24 0 0 0 19.749 9.713q.35.027.7 0a5.4 5.4 0 0 0 3.59-1.364 5.39 5.39 0 0 0 1.796-4.022v-5.386a5.386 5.386 0 0 0-4.345-5.242m.88 10.773a1.8 1.8 0 0 1-.593 1.328 1.8 1.8 0 0 1-1.472.45 30.8 30.8 0 0 1-17.72-8.69 30.8 30.8 0 0 1-8.761-17.774 1.8 1.8 0 0 1 .448-1.473 1.8 1.8 0 0 1 1.347-.592h5.386a1.796 1.796 0 0 1 1.796 1.4c0 .485.161.988.269 1.472q.311 1.413.826 2.765l-2.514 1.185c-.432.199-.768.56-.933 1.006-.18.437-.18.927 0 1.364a26 26 0 0 0 12.567 12.568c.437.18.927.18 1.365 0a1.8 1.8 0 0 0 1.005-.934l1.131-2.513a22.3 22.3 0 0 0 4.291 1.095 1.795 1.795 0 0 1 1.4 1.795z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#86D6F8",
    d: "M40.655 15h-1.257a1.802 1.802 0 1 0 .305 3.59h.952a10.773 10.773 0 0 1 10.772 10.773v.951a1.795 1.795 0 0 0 1.634 1.94h.144A1.795 1.795 0 0 0 55 30.62v-1.257A14.363 14.363 0 0 0 40.655 15m3.59 14.363a1.795 1.795 0 1 0 3.592 0 7.18 7.18 0 0 0-7.182-7.181 1.795 1.795 0 1 0 0 3.59 3.59 3.59 0 0 1 3.59 3.59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.7228b9ceb8adbf4c20186c3be3d52e2f.svg";
export { ForwardRef as ReactComponent };